import BackendDeveloperPage from "./BackendDeveloperPage";

export default function UnityDeveloperPage() {
  return <BackendDeveloperPage technology="unity" />;
}
